import { useCallback, useState } from 'react'
import cloneDeep from 'lodash/cloneDeep'

import { useUpdateTouts } from './useUpdateTouts'
import { useUpdateRecentlyPlayedGames } from './useUpdateRecentlyPlayedGames'
import { getPlayerStatus } from '../../../services/helpers/playerHelper'
import { useParseLobbyData } from './parsers/useParseLobbyData'
import { usePlayerStore } from '../../../services/store'
import { useSetCasinoLobby } from '../../../services/store/casinoStore/casinoActions'

export const useParseLobby = isPlayerDataLoading => {
  const playerStore = usePlayerStore()
  const playerData = playerStore.useAllPlayerStore()
  const previousGames = playerStore.use.previousGames()

  const { leaderboardGames, updateTouts } = useUpdateTouts()
  const { updateRecentlyPlayedGames } = useUpdateRecentlyPlayedGames()

  const { parseLobbyData } = useParseLobbyData()
  const { setCasinoLobby } = useSetCasinoLobby()

  const [lobbyReady, setLobbyReady] = useState(false)

  const parseLobby = useCallback(
    (data, lazyLoadedCategoryIds, showLoading = false) => {
      if (showLoading) {
        setLobbyReady(false)
      }

      const parsedLobbyData = parseLobbyData(cloneDeep(data), {
        lazyLoadedCategoryIds: lazyLoadedCategoryIds
      })

      if (parsedLobbyData.categories) {
        if (getPlayerStatus(playerData) === 'logged-in') {
          const categoriesWithRecentlyPlayedGames = updateRecentlyPlayedGames({
            categories: parsedLobbyData.categories,
            previousGames: previousGames
          })

          updateTouts(categoriesWithRecentlyPlayedGames).then(categoriesWithParsedTouts => {
            const newLobbyData = { ...parsedLobbyData }
            newLobbyData.categories = categoriesWithParsedTouts

            setCasinoLobby(newLobbyData)

            setLobbyReady(true)
          })
        }

        if (getPlayerStatus(playerData) !== 'logged-in' && !isPlayerDataLoading) {
          setCasinoLobby(parsedLobbyData)

          setLobbyReady(true)
        }
      }
    },
    [
      parseLobbyData,
      playerData,
      isPlayerDataLoading,
      updateRecentlyPlayedGames,
      previousGames,
      updateTouts,
      setCasinoLobby
    ]
  )

  return { lobbyReady, setLobbyReady, leaderboardGames, parseLobby }
}
